module.exports = __webpack_public_path__ + "static/media/wellRecord2.png";